import {
  type PopupProps,
  Leaderboard as LeaderboardPopup
} from '@CS/components/Popups';

import API from '@/services/api';
import { useGameRange, useAppSelector } from '@/hooks';
import { getUserUsername, getUserTeamId } from '@/redux/user';

type LeaderboardProps = PopupProps & {
  game?: number;
};

export const Leaderboard = ({ game, ...props }: LeaderboardProps) => {
  const username = useAppSelector(getUserUsername);
  const campaignGame = API.getCampaignGame(game);
  const teamId = useAppSelector(getUserTeamId);
  const week = useGameRange(campaignGame);

  const getWeekScores = async (week: number) => {
    const leaderboard = await API.getCampaignLeaderboard({
      rangeNumber: week + 1,
      gameIndex: game,
      limit: 10,
      teamId
    });

    const {
      position = -1,
      participant: { score = 0 }
    } = leaderboard.my ?? {
      participant: {}
    };

    return {
      userData: { name: username ?? '', position, score },

      weekScores: leaderboard.items.map(({ user, score }) => ({
        name: user.username,
        score: score
      }))
    };
  };

  return (
    <LeaderboardPopup
      getWeekScores={getWeekScores}
      currentWeek={week}
      {...props}
    />
  );
};
